import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../../../../core/services/language.service';
import { ApiNewsService } from '../../../../../core/services/api/News/api-news';
import { PublicNewsListItem } from '../../../../../core/models/news.model';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';

@Component({
  selector: 'app-news-list',
  standalone: true,
  imports: [CommonModule, PssLoadingComponent],
  templateUrl: './news-list.component.html',
  styleUrl: './news-list.component.css',
})
export class NewsListComponent implements OnInit, OnDestroy {
  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;

  items: PublicNewsListItem[] = [];
  page = 1;
  pageSize = 20;
  totalCount = 0;
  isLoading = false;
  isLoadingMore = false;
  /** ?lot=<publicRef> → ประกาศจากลานนั้นเท่านั้น */
  lotRef = '';
  lotName = '';

  constructor(
    private languageService: LanguageService,
    private apiNews: ApiNewsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  /*#################################################### Function ################################################*/
  ngOnInit(): void {
    this.lotRef = String(this.route.snapshot.queryParamMap.get('lot') || '').trim();
    this.loadNews(true);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  goBack(): void {
    if (this.lotRef) {
      this.router.navigate(['/lot', this.lotRef]);
      return;
    }
    this.router.navigate(['/home']);
  }

  openDetail(id: number): void {
    this.router.navigate(['/news-detail', id]);
  }

  get hasMore(): boolean {
    return this.items.length < this.totalCount;
  }

  titleOf(item: PublicNewsListItem): string {
    if (this.currentLang === 'EN' && item.titleEn?.trim()) return item.titleEn;
    return item.title;
  }

  formatDate(value?: string | null): string {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
  }

  loadMore(): void {
    if (!this.hasMore || this.isLoadingMore) return;
    this.page += 1;
    this.loadNews(false);
  }

  /*############################################# API #################################################*/
  loadNews(reset: boolean): void {
    if (reset) {
      this.page = 1;
      this.isLoading = true;
    } else {
      this.isLoadingMore = true;
    }

    const request$ = this.lotRef
      ? this.apiNews.getPublicSiteNews(this.lotRef, this.page, this.pageSize)
      : this.apiNews.getPublicNews(null, null, this.page, this.pageSize);

    request$.subscribe({
      next: (res) => {
        console.log('news list', res);
        const list = res?.items ?? [];
        this.totalCount = res?.totalCount ?? 0;
        this.items = reset ? list : [...this.items, ...list];
        if (this.lotRef && !this.lotName) {
          this.lotName = list.find((x) => x.siteName)?.siteName ?? '';
        }
        this.isLoading = false;
        this.isLoadingMore = false;
      },
      error: (err) => {
        console.error('getPublicNews failed', err);
        this.isLoading = false;
        this.isLoadingMore = false;
      },
    });
  }
}
